module.exports = __webpack_public_path__ + "media/images/landing/second/photo11-6852af73fde6f49addf715c0e6e49cfc.jpg";